import { Model } from "survey-core";
import type { SurveyBlocker, Workflow } from "./types";

export function surveyIdToWorkflow(surveyId: string): Workflow {
  switch (surveyId) {
    case "precision-guidance-survey":
      return "precision_guidance_survey";
    case "detailed-cancer-survey":
      return "cancer_survey";
    case "kit-request-questions":
      return "kit_request_survey";
    default:
      return "health_survey";
  }
}

/**
 * Derives workflow-blocking survey answers captured at summary confirmation.
 * These answers change which member jobs remain available (e.g. kit ordering).
 */
export function deriveSurveyBlockers(surveyModel: Model): SurveyBlocker[] {
  const blockers: SurveyBlocker[] = [];

  const everHadCancer = surveyModel.getQuestionByName(
    "have-you-ever-been-told-you-have-cancer"
  );
  const cancerStatus = surveyModel.getQuestionByName(
    "which-cancer-status-best-applies-to-you"
  );
  const cancerType = surveyModel.getQuestionByName("cancer-type");
  const dnaTransplant = surveyModel.getQuestionByName(
    "have-you-had-a-dna-transplant"
  );

  if (everHadCancer?.value === true) {
    if (cancerStatus?.value === "history-of-cancer") {
      blockers.push("history_of_cancer");
    } else if (cancerStatus?.value === "active-cancer") {
      blockers.push("active_cancer");
    } else {
      blockers.push("uncertain_cancer_status");
    }

    if (cancerType?.value === "basal-cell-or-squamous-cell-skin-cancer") {
      blockers.push("basal_cell_skin_cancer");
    }
  } else if (dnaTransplant?.value && dnaTransplant?.value !== "no") {
    blockers.push("dna_transplant");
  }

  return blockers;
}

export function surveyOutcomeFromBlockers(
  blockers: SurveyBlocker[]
): "completed" | "blocked" {
  return blockers.length > 0 ? "blocked" : "completed";
}
